import { createContext } from 'reka-ui'

export interface AccessRolePermissionGroupContext {
  groupName: string
  addPermissionItemToSearchResult: (id: string) => void
  removePermissionItemFromSearchResult: (id: string) => void
}

export const [
  useAccessRolePermissionGroup,
  provideAccessRolePermissionGroupContext
] = createContext<AccessRolePermissionGroupContext>(
  'access-role-permission-group'
)
